import { render, staticRenderFns } from "./FileDropUpload.vue?vue&type=template&id=4dfa6a76&scoped=true"
import script from "./FileDropUpload.vue?vue&type=script&lang=js"
export * from "./FileDropUpload.vue?vue&type=script&lang=js"
import style0 from "./FileDropUpload.vue?vue&type=style&index=0&id=4dfa6a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfa6a76",
  null
  
)

export default component.exports